import { Avatar, Card, Row, Space, Tag } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import {
  TextRegular12,
  TextRegular14,
  TextSemibold14,
} from 'styles/typography';
import { getTaskStatusText } from 'utils/helpers';
import { ITask } from '../../slice/types';
import moment from 'moment';

interface IProps {
  task: ITask | null;
}

const DeclinedTaskComment: FC<IProps> = ({ task }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (task?.status !== 'DECLINED') {
    return null;
  }
  // TODO: probably bug in future, but currently nobody can change Declined task,
  // so last person who updated task (declined it) is the comment author
  const authorName = task.updatedBy?.name;
  const authorLastName = task.updatedBy?.lastName;
  const authorEmail = task.updatedBy?.email;

  const formattedDate = moment(`${task.updatedAt}Z`)
    .local()
    .format('YYYY-MM-DD HH:mm');

  return (
    <Card style={{ margin: '12px 0' }}>
      <Row justify="space-between">
        <TextSemibold14>
          {t('Task.List.TaskStatus', 'Task status')}
        </TextSemibold14>
        <Tag style={{ margin: 0 }} color={theme.taskStatusColor[task.status]}>
          {getTaskStatusText(task.status)}
        </Tag>
      </Row>

      <Row
        align="middle"
        justify="space-between"
        style={{ margin: '15px 0 8px' }}
      >
        <Space>
          <Avatar style={{ backgroundColor: '#FFC53D' }}>
            {(authorName || authorEmail)?.charAt(0) ?? ''}
          </Avatar>
          <TextRegular14>
            {authorName && authorLastName
              ? `${authorName} ${authorLastName}`
              : authorEmail}
          </TextRegular14>
        </Space>
        <TextRegular12 style={{ color: '#BFBFBF' }}>
          {formattedDate}
        </TextRegular12>
      </Row>
      <TextRegular12 style={{ color: '#595959' }}>
        {task.recommendation?.comment}
      </TextRegular12>
    </Card>
  );
};

export default DeclinedTaskComment;
